<button mat-icon-button
  disableRipple="true"
  [matMenuTriggerFor]="menu"
  #menuTrigger="matMenuTrigger"
  class="filter-icon"
  [matTooltip]="'Filtros'"
  [matBadge]="appliedFilters[column] || (sortColumn ? sortColumn === column : null)"
  [matBadgeHidden]="!appliedFilters[column] && (sortColumn !== column )">
  <img src="../../../assets/icons/filter-icon.svg">
</button>